import React from 'react';
import { Icons, SVG } from '../../../components/atoms/SVG';
import { PageType } from '../../../types/api/PageType';

type FooterLinkProps = {
  pageType: PageType
};

/**
 * only page types simplelanguage and signlanguage have svg icons
 * @param pageType
 * @constructor
 */
export function FooterLinkIcon({ pageType }: FooterLinkProps) {
  const getIcon = () => {
    if (pageType === 'simplelanguage') {
      return Icons.SIMPLE_LANGUAGE;
    }
    if (pageType === 'signlanguage') {
      return Icons.SIGN_LANGUAGE;
    }
  };

  if (pageType === 'simplelanguage' || pageType === 'signlanguage') {
    return (
      <span className="footer__svg">
        <SVG svgSpriteId={getIcon()} />
      </span>
    );
  }

  return null;
}
